import React from 'react';
import styles from './logo.module.scss';

interface IProps {
  imageUrl: string,
  baseURL: string,
  onClick?: () => void,
  logoStyle?: string
};

const Logo: React.FC<IProps> = (props) => {
  const { baseURL, imageUrl, logoStyle, onClick } = props;

  return (
    <div className={`${styles.container} ${logoStyle}`} onClick={onClick!}>
      <img src={`${baseURL}${imageUrl}`} alt='logo.png' className={styles.img} />
    </div>
  )
}

export default Logo
